import "twin.macro";

import { Edit } from "lucide-react";
import { useState } from "react";

import { PageContent } from "@/components/page";
import { useClientContext } from "@/data-loaders/client-data-loader";

import { UpdateClientModalForm } from "./UpdateClientFormModale";

const InformationsCard = () => {
  const client = useClientContext();

  const [openUpdateClientModal, setOpenUpdateClientModal] = useState(false);

  const openUpdateModale = () => {
    setOpenUpdateClientModal(true);
  };

  return (
    <PageContent tw="max-w-7xl">
      <div tw="flex flex-col gap-4 px-4 py-5 sm:p-6 bg-white rounded-xl shadow-sm z-10">
        <div tw="flex items-start justify-between">
          <div>
            <div>
              Adresse :{" "}
              <span tw="font-bold text-secondary-950">{client?.address}</span>
            </div>
            <div tw="flex gap-4">
              <div>
                Ville :{" "}
                <span tw="font-bold text-secondary-950">{client?.city}</span>
              </div>
              <div>
                Code postal :{" "}
                <span tw="font-bold text-secondary-950">{client?.zipcode}</span>
              </div>
            </div>
            <div>
              Région :{" "}
              <span tw="font-bold text-secondary-950">{client?.region}</span>
            </div>
            <div>
              Téléphone :{" "}
              <span tw="font-bold text-secondary-950">{client?.tel}</span>
            </div>
          </div>
          <Edit
            tw="w-5 h-5 text-primary-950 cursor-pointer"
            onClick={openUpdateModale}
          />
        </div>
      </div>

      {client && (
        <UpdateClientModalForm
          open={openUpdateClientModal}
          setOpen={setOpenUpdateClientModal}
          client={client}
        />
      )}
    </PageContent>
  );
};

export default InformationsCard;
